<template>
  <div class="gWidth detail_box">
    <div class="detail_L" v-if="!news_id_ss">
      <span>
        <el-popover
          trigger="hover"
          placement="right"
          width="150"
          v-model:visible="visible"
        >
          <div id="qrCode" ref="qrCodeDiv"></div>
          <template #reference>
            <span class="cuP" style="margin-top: -1px"
              ><i class="el-icon-s-promotion activeY1"></i>分享</span
            >
          </template>
        </el-popover>
      </span>
      <span @click="collect_news(detail_l.is_collect)"
        ><i
          :style="{ color: detail_l.is_collect ? '#e6a23c' : '' }"
          class="el-icon-star-on activeLL"
          style="font-size: 50px"
        ></i
        >收藏</span
      >
    </div>
    <el-card class="detail_R">
      <h2 class="title">{{ detail_l.title }}</h2>
      <b>{{ detail_l.public_time }} ({{ detail_l.reprinted }})</b>
      <el-divider></el-divider>
      <div v-html="detail_l.content"></div>
    </el-card>
  </div>
</template>
<script>
import { ref, getCurrentInstance, inject } from 'vue'
import { useRouter } from 'vue-router'
import QRCode from 'qrcodejs2'
export default {
  props: ['news_id_ss'],
  setup(props) {
    let { proxy: _this } = getCurrentInstance()
    let router = useRouter()
    let news_id = router.currentRoute.value.params.news_id || props.news_id_ss
    console.log(props.news_id_ss)
    // let qs = require('qs')
    // 刷新
    const refresh = inject('reload')
    // console.log(news_id)
    // 初始新闻详情
    let detail_l = ref([])
    let soccer_news = async () => {
      let { data: res } = await _this.$http.get(
        `/news/soccer${
          router.currentRoute.value.params.soccer
            ? router.currentRoute.value.params.soccer
            : ''
        }/${news_id}`
      )
      res.data.content = res.data.content.replace(/href/g, 'aaa')
      detail_l.value = res.data
    }
    soccer_news()
    // 二维码生成
    console.log(router.currentRoute.value.fullPath)
    console.log(router.currentRoute.value.params.soccer)
    let qrCodeDiv = ref('')
    let qrcode = () => {
      setTimeout(() => {
        new QRCode(
          qrCodeDiv.value,
          {
            text: `http://deyity.com${router.currentRoute.value.fullPath}`,
            width: 150,
            height: 150,
            colorDark: '#333333', // 二维码颜色
            colorLight: '#ffffff', // 二维码背景色
            correctLevel: QRCode.CorrectLevel.H // 容错率L/M/H
          },
          100
        )
      })
    }
    qrcode()
    // 收藏新闻
    let collect_news = async (v) => {
      // console.log(v)
      let collect_type
      if (v == 0) collect_type = 1
      if (v == 1) collect_type = 2
      let data = new FormData()
      data.append('news_id', news_id)
      data.append('collect_type', collect_type)

      await _this.$http.post(`/auth/user/collect_news`, data)
      refresh()
    }
    return {
      detail_l,
      qrCodeDiv,
      visible: ref(false),
      collect_news
    }
  }
}
</script>
<style lang="less">
.detail_box {
  width: 1010px;
  display: flex;
  justify-content: space-between;
}
.detail_L {
  width: 100px;
  height: 200px;
  background: #fff;
  display: flex;
  flex-direction: column;
  span {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    margin-top: 20px;
    i {
      font-size: 40px;
    }
  }
}
.detail_R {
  width: 900px;
  .title {
    text-align: center;
    color: #444;
  }
  b {
    font-size: 14px;
    display: block;
    text-align: center;
    color: #606266;
  }
  p {
    // text-indent: 2em;
    // line-height: 26px;
    margin: 20px 0 !important;
  }
  img {
    width: 100%;
    display: block;
    margin: 10px 0;
  }
}
</style>
